/**
 * Policy Analysis
 * 분석 > 정책/객체 트래픽 분석
 */

import Moment from 'moment'

const url = {
  deviceTree: '/api/sm/devices-tree',
  fwTrafficAnalysis: '/api/pm/fw-traffic-analysis'
}

export const state = () => ({
  devicesTreeData: [],
  selectedDevice: void 0,
  selectedDeviceText: '',
  fwTrafficAnalysisData: []
})

export const mutations = {
  initStore (state) {
    state.devicesTreeData = []
    state.selectedDevice = void 0
    state.selectedDeviceText = ''
    state.fwTrafficAnalysisData = []
  },
  devicesTreeData (state, devicesTreeData) {
    state.devicesTreeData = devicesTreeData
  },
  selectedDevice (state, selectedDevice) {
    state.selectedDevice = selectedDevice
  },
  selectedDeviceText (state, selectedDeviceText) {
    state.selectedDeviceText = selectedDeviceText
  },
  fwTrafficAnalysisData (state, fwTrafficAnalysisData) {
    state.fwTrafficAnalysisData = fwTrafficAnalysisData
  }
}

export const actions = {
  setSelectedDevice ({ commit }, selectedDevice) {
    commit('selectedDevice', selectedDevice)
  },
  setSelectedDeviceText ({ commit }, selectedDeviceText) {
    commit('selectedDeviceText', selectedDeviceText)
  },
  async getDevicesTreeData ({ commit }) {
    const { code, result } = await this.$axios.$get(url.deviceTree)

    if (code === 'ok') {
      commit('devicesTreeData', result)
    }
  },
  async getFwTrafficAnalysisData ({ commit }, { startDate, endDate, deviceId }) {
    const requestUrl = `${url.fwTrafficAnalysis}/${deviceId}`
    const { code, result } = await this.$axios.$post(requestUrl,
      {
        start_time: Moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
        end_time: Moment(endDate).format('YYYY-MM-DD HH:mm:ss')
      },
      {
        successAlert: false
      }
    )

    if (code === 'ok') {
      commit('fwTrafficAnalysisData', result)
    }
  }
}

export const getters = {}
export const strict = false
